module.exports = __webpack_public_path__ + "img/file-word-fill.aece965d.svg";